import { useState } from "react";
import { useCustom } from "@refinedev/core";
import { Boxes } from "lucide-react";
import { Modal } from "@fawkes/ui";
import { OverviewHeader } from "../components/OverviewHeader";
import { useTranslate } from "@refinedev/core";

import { ProductList } from "./ProductList";
import { ProductDetail } from "./ProductDetail";

// producten-catalogus: het beheerscherm van de productcatalogus.
//
// Het Jmix-scherm had hier drie tabbladen — Catalogus / Statistieken / Trends — en die zijn hier
// eerst nagebouwd. Statistieken en Trends horen echter bij de managementtool en niet bij het
// beheer van de catalogus; ze zijn hier weggehaald (de api-endpoints blijven staan, die bedienen
// die tool). Met alleen Catalogus over is er geen tabblad meer te kiezen, dus de strook is ook weg:
// één tabblad is geen keuze maar een streep boven het scherm.
//
// Een rij openen zet `detailId` en toont ProductDetail (met zijn eigen tabbladen); "terug" wist het.

export function ProductsOverview() {
  const t = useTranslate();
  const [detailId, setDetailId] = useState<string | null>(null);
  // Op welke vestigingen de lijst kijkt. Stond hier als keuzelijst met drie vaste antwoorden
  // (Beide / Hele organisatie / Alleen deze vestiging); dat zegt wel iets over het soort product,
  // maar niet wélke vestiging je bedoelt. Nu dezelfde kiezer als het factuuroverzicht: zoeken,
  // "Alles aan", en aanvinken wat je wilt zien. Niets aangevinkt = alles.
  const [vestigingen, setVestigingen] = useState<string[]>([]);
  const { data: vestigingFeed } = useCustom<{ id: number; naam: string }[]>({
    url: "vestigingen",
    method: "get",
  });
  const vestigingLijst = (vestigingFeed?.data ?? [])
    .filter((v) => !!v.naam)
    .sort((a, b) => a.naam.localeCompare(b.naam, "nl"));
  const alleVestigingen = vestigingLijst.map((v) => v.naam);
  // De kiezer werkt op namen (dat is wat je leest); de lijst filtert op id.
  const gekozenIds = vestigingLijst.filter((v) => vestigingen.includes(v.naam)).map((v) => v.id);



  return (
    <div className="product-overview">
      {/* acc heads the screen with the title (+ the Scope selector) and puts the tab strip UNDER it;
          we had the tabs on top and the title inside the Catalogus panel, so the page read as a tab
          bar with three unrelated screens behind it. */}
      <OverviewHeader
        icon={<Boxes size={24} />}
        title={t("productListView.title")}
      />

      <ProductList
        onOpen={setDetailId}
        vestigingIds={gekozenIds}
        vestigingKeuze={{ opties: alleVestigingen, gekozen: vestigingen, onChange: setVestigingen }}
      />

      {/* Een product openen is een dialoog over de lijst heen, zoals op acc ("Product wijzigen").
          Dat is niet alleen vorm: de lijst blijft eronder staan, dus na sluiten sta je weer op
          dezelfde pagina met dezelfde filters in plaats van bovenaan een verse lijst. */}
      <Modal
        open={detailId !== null}
        title={t("productEditView.title")}
        onClose={() => setDetailId(null)}
        size="full"
      >
        {detailId && <ProductDetail id={detailId} onBack={() => setDetailId(null)} />}
      </Modal>
    </div>
  );
}
